const userValidateRemote = async (
  name,
  field,
  validator,
  isEmail,
  isPassword,
  graphQLError,
  setGraphQLError,
  tryValidateRemote,
  trySubmit,
  getError,
) => {
  if (!field.match(validator)) {
    return setGraphQLError({
      ...graphQLError,
      [name]: getError(isEmail, isPassword),
    })
  }

  const { isValid, errorMessages } = await tryValidateRemote(
    name,
    field,
    isEmail,
    isPassword,
  )
  if (!isValid) {
    return setGraphQLError({
      ...graphQLError,
      [name]: errorMessages,
    })
  }
  return trySubmit()
}

export default userValidateRemote
